import React from "react";

/* ============================================================================
 * HomeAbout — จุดเด่นบริการ + แถบตัวเลขความน่าเชื่อถือ
 *
 * 2 คอลัมน์ : เหตุผลที่ควรเลือกเรา (ซ้าย) คู่กับตัวเลขที่พิสูจน์เหตุผลนั้น (ขวา)
 * อ่านจบในสายตาเดียว ไม่ต้องเลื่อนลงไปหาตัวเลขอีกชั้น
 *
 * เนื้อหาแก้ได้จากหลังบ้าน — section "highlight" (จุดเด่น) และ "stat" (ตัวเลข)
 * ไม่มีทั้งคู่ = ไม่แสดงทั้ง section ดีกว่าโชว์กรอบเปล่า
 * ========================================================================== */
export default function HomeAbout({ items = [], stats = [], title }) {
    if (!items.length && !stats.length) return null;

    return (
        <section className="hm-section" id="hm-about">
            <div className="hm-container">
                <div className="hm-section__head hm-section__head--tight">
                    <h2 className="hm-section__title hm-section__title--sm">{title || "ทำไมต้องเลือกเรา"}</h2>
                </div>

                <div className="hm-about">
                    <div className="hm-features">
                        {items.map((item) => (
                            <div className="hm-feature" key={item.uid}>
                                <div className="hm-feature__icon hm-ico">{item.icon || ""}</div>
                                <div className="hm-feature__title">{item.title}</div>
                                <p className="hm-feature__desc">{item.body}</p>
                            </div>
                        ))}
                    </div>

                    {!!stats.length && (
                        <div className="hm-stats">
                            {stats.map((item) => (
                                <div className="hm-stat" key={item.uid}>
                                    <div className="hm-stat__value">{item.title}</div>
                                    <div className="hm-stat__label">{item.subtitle}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
